import { render, staticRenderFns } from "./preference.component.vue?vue&type=template&id=1e11b492&scoped=true"
import script from "./preference.component.vue?vue&type=script&lang=js"
export * from "./preference.component.vue?vue&type=script&lang=js"
import style0 from "./preference.component.vue?vue&type=style&index=0&id=1e11b492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e11b492",
  null
  
)

export default component.exports